import { api } from "./client";

/* Mirrors api/routers/page_resolution.py — keep in sync.
   Page image width per crawled edition (clip.PageImageInfo, measured on np92). SuperAdmin + Admin. */

export const BANDS = ["<600", "600–800", "800–1200", "≥1200", "unmeasured"] as const;
export const CATEGORIES = ["Financial", "Mainline", "Regional", "Other"] as const;
export const CROP_STATUSES = ["done", "skipped", "pending", "failed", "none"] as const;

export interface ResParams {
  date?: string;
  category: string[];
  band: string[];
  language?: string;
  publisher?: string;
  crop: string[];
}

export interface EditionRow {
  issue_id: number;
  edition_id: number | null;
  channel_id: number | null;
  publisher: string;
  edition: string;
  language: string;
  category: string;
  page_count: number | null;
  pages_measured: number;
  min_width: number | null;
  max_width: number | null;
  max_height: number | null;
  bytes: number | null;
  band: string;
  crop_status: string;
}

export interface ResResponse {
  date: string;
  crop_min_width: number;
  totals: { editions: number; measured_editions: number; below_crop_min: number };
  languages: string[];
  summary: { bands: string[]; categories: string[]; cells: Record<string, Record<string, { editions: number; pages: number }>> };
  rows: EditionRow[];
}

function toQuery(p: ResParams): Record<string, string> {
  const q: Record<string, string> = {};
  if (p.date) q.date = p.date;
  if (p.category.length) q.category = p.category.join(",");
  if (p.band.length) q.band = p.band.join(",");
  if (p.crop.length) q.crop = p.crop.join(",");
  if (p.language) q.language = p.language;
  if (p.publisher) q.publisher = p.publisher;
  return q;
}

export async function fetchPageResolution(p: ResParams): Promise<ResResponse> {
  const r = await api.get("/api/page-resolution/editions", { params: toQuery(p) });
  return r.data as ResResponse;
}

/** CSV goes through axios so the bearer token is sent; saved via an object URL. */
export async function downloadPageResolutionCsv(p: ResParams): Promise<void> {
  const r = await api.get("/api/page-resolution/editions.csv", { params: toQuery(p), responseType: "blob" });
  const url = URL.createObjectURL(r.data as Blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `page-resolution-${p.date || "today"}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
